<template>
  <div>
    <b-row>
      <b-col
        xl="6"
        lg="6"
        md="12"
        sm="12"
        xs="12"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 761 472"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M701.364 470.235H701.365H760.5V440.365V409.995V239.796V69.5979V30.764L736.047 0.5H0.499939V30.37V60.7399V407.464V447.292L24.9199 471.5L701.364 470.235Z"
            stroke="#00B058"
          />
          <path
            d="M54 470H24.6821L2 447V421"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M707 2H736.318L759 25V51"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            x="25"
            y="15"
            width="300"
            height="150"
          >
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.1875 5V27.5H17.8125V5C17.8125 3.625 17.25 2.5 15.5625 2.5H14.4375C12.75 2.5 12.1875 3.625 12.1875 5ZM3.75 12.5V27.5H8.75V12.5C8.75 11.125 8.25 10 6.75 10H5.75C4.25 10 3.75 11.125 3.75 12.5ZM21.25 18.75V27.5H26.25V18.75C26.25 17.375 25.75 16.25 24.25 16.25H23.25C21.75 16.25 21.25 17.375 21.25 18.75Z"
                fill="url(#paint0_linear_77_48)"
              />
              <path
                d="M25.9375 28.125H4.6875C2.1 28.125 0 26.025 0 23.4375V2.1875C0 1.675 0.425 1.25 0.9375 1.25C1.45 1.25 1.875 1.675 1.875 2.1875V23.4375C1.875 24.9875 3.1375 26.25 4.6875 26.25H25.9375C26.45 26.25 26.875 26.675 26.875 27.1875C26.875 27.7 26.45 28.125 25.9375 28.125Z"
                fill="url(#paint1_linear_77_48)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_77_48"
                  x1="15"
                  y1="2.5"
                  x2="15"
                  y2="27.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFB9DF" />
                  <stop
                    offset="1"
                    stop-color="#FF005C"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_77_48"
                  x1="13.4375"
                  y1="1.25"
                  x2="13.4375"
                  y2="28.125"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFB9DF" />
                  <stop
                    offset="1"
                    stop-color="#FF005C"
                  />
                </linearGradient>
              </defs>
            </svg>

          </foreignObject>
          <foreignObject
            x="70"
            y="17"
            width="100%"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>กราฟแสดงจำนวนครั้งที่กด (วัน)</strong>
            </div>
          </foreignObject>
          <foreignObject
            x="495"
            y="65"
            width="100%"
            height="150"
            color="#ffffff"
          >
            <div>
              <span style="font-size:16px; color: #F9F9DD;">จำนวนการใช้ทางข้าม: </span>&nbsp;&nbsp;
              <strong style="font-size:20px;"> {{ ticker }} </strong> &nbsp;&nbsp;<span style="font-size:16px;">ครั้ง/วัน</span>
            <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="50"
            width="100%"
            height="100%"
            color="#ffffff"
            font-size="20"
          >
            <div class="mt-2">
              <app-echar-line
                :option-data="option"
              />
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <!-- frame Top 5 สายทางที่มีปริมาณจราจรต่อชั่วโมงมากที่สุด -->
      <b-col
        xl="6"
        lg="6"
        md="12"
        sm="12"
        xs="12"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 761 472"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M701.364 470.235H701.365H760.5V440.365V409.995V239.796V69.5979V30.764L736.047 0.5H0.499939V30.37V60.7399V407.464V447.292L24.9199 471.5L701.364 470.235Z"
            stroke="#00B058"
          />
          <path
            d="M54 470H24.6821L2 447V421"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M707 2H736.318L759 25V51"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            x="25"
            y="15"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <b-img
                src="@/assets/images/iconsDB/icontime.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            x="70"
            y="17"
            width="100%"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>การใช้งานทางข้าม</strong>
            <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="18"
            y="-20"
            width="100%"
            height="100%"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <div v-if="img">
                <!-- <span class="text1">ภาพการวิเคราะห์จราจรล่าสุด</span> -->
                <b-img
                  :src="img"
                  class="mb-1"
                  style="width:80%; margin-left: 70px; margin-top: 90px; height:auto; flex-direction: row;"
                />
                <br>
                <center>
                  <span style="font-size:18px; color:#ffffff">การใช้งานทางข้ามล่าสุด : {{ Ldate }}</span>
                </center>
              </div>
              <div
                v-else
                style="margin-right: 70px; margin-top: -20px;"
              >
                <center>
                  <img
                    height="500px"
                    src="@/assets/images/icons/markeranalytic120/Noimage.svg"
                  >
                </center>
              </div>
            </div>
          </foreignObject>
        </svg>

      </b-col>

      <!-- frame สถิติการตรวจสอบเหตุการณ์ที่อาจจะเกิดอุบัติเหตุภายใน 7 วัน (Analytic) -->

    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import axios from '@axios'
import * as echarts from 'echarts'
import AppEcharLine from '@/views/crosswalk/detail/AppEchartLineDB.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    AppEcharLine,
  },
  data() {
    return {
      img: '',
      Ldate: '',
      ticker: '',
      statisticTitle: '',
      Total: '',
      option: {
        xAxisData: [],
        series: [
          {
            name: 'กดอัตโนมัติ',
            type: 'line',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00B058' },
                { offset: 1, color: 'rgba(4, 22, 22, 0.1)' },
              ]),
            },
            color: '#00B058',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
          {
            name: 'กดปุ่ม',
            type: 'line',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FDFF01' },
                { offset: 1, color: 'rgba(4, 22, 22, 0.1)' },
              ]),
            },
            color: '#FDFF01',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    setInterval(this.getNow, 1000)
    this.interval = setInterval(() => {
      this.getChartCrossWalk()
      this.getLastImgCrossWalk()
      this.gettickerCrossWalk()
    }, 300000)
  },
  mounted() {
    this.getChartCrossWalk()
    this.getLastImgCrossWalk()
    this.gettickerCrossWalk()
  },
  methods: {
    // ด้านซ้าย กราฟการกดปุ่มทางข้าม
    getChartCrossWalk() {
      axios
        .post('/graphCrossWalkDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisData = []
          this.option.xAxisData.splice(0)
          this.option.series[0].data.splice(0)
          this.xAxisData[0] = response.data
          this.xAxisData[0][0].forEach(value => {
            this.option.xAxisData.push(value.Period_Name)
            this.option.series[0].data.push(value.Ticker)
          })
          this.xAxisData[0][1].forEach(value => {
            this.option.series[1].data.push(value.Ticker)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    // ด้านขวา รูปภาพการใช้ทางข้ามล่าสุด
    getLastImgCrossWalk() {
      axios
        .post('/tableCrossWalkDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.img = response.data[0].FilePath
          this.Ldate = response.data[0].DATE_TIME
        })
        .catch(error => {
          console.log(error)
        })
    },

    gettickerCrossWalk() {
      axios
        .post('/tickerCrossWalkDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.ticker = response.data[0].Total_Ticker
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
  </style>
